import { Module } from 'vuex'
import { ConfigurationStoreState } from '@/modules/configurationModule/store/configuration-store.model'
import { RootStoreState } from '@/store/root/root-store.model'
import { VtStore } from '@/store/vt-store'

const initialConfigurationStoreState =
    (): ConfigurationStoreState => ({
        tabIndex: 0
    })

const module: Module<ConfigurationStoreState, RootStoreState> = {
    namespaced: true,
    state: initialConfigurationStoreState,
    getters: {
        tabIndex: (state): number => state.tabIndex
    },
    mutations: {
        updateTabIndex: (state: ConfigurationStoreState, payload: number): void => { state.tabIndex = payload }
    }
}
export const configurationStore = new VtStore<ConfigurationStoreState>('configuration', module)
